import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, of } from 'rxjs';
import { RestService } from './rest.service';
import { map } from 'rxjs/operators';
import * as _ from 'lodash'
@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  isSaveChangesEnabled: boolean = false;
  isProfile = new Subject();
  private appSteps: Subject<string> = new Subject();
  private notification = new Subject();
  sharedNotification = this.notification.asObservable();
  private invites = new Subject();
  public filters = new BehaviorSubject<any>("");
  filter$ = this.filters.asObservable();
  constructor(private restService: RestService) { }

  isValidEmail(email) {
    // tslint:disable-next-line:max-line-length
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return emailRegex.test(email);
  }

  isPasswordStrong(password: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // tslint:disable-next-line:max-line-length
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/;
        const isValid = passwordRegex.test(password);
        if (isValid) {
          resolve(true);
        } else {
          resolve(false);
        }
      }, 100);
    });
  }

  getAllAgencies(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/organization/agencies/search?term=${term}`)
        .pipe(map(agencies => agencies));
    } else {
      return of(defaultData);
    }
  }

  getWallets(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/wallets/search?term=${term}`)
        .pipe(map(wallets => _.map(wallets, (wallet) => {
          wallet['name'] = wallet.userName || wallet.organizationName
          return wallet
        })));
    } else {
      return of(defaultData);
    }
  }

  searchWholesaleAgencies(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/agents/wholesale/search?term=${term}`)
        .pipe(map(agencies => agencies));
    } else {
      return of(defaultData);
    }
  }

  searchProducts(term?: string, defaultData: any[] = []) {
    if (term) {
      return this.restService
        .fetch(`/api/products/search/by?term=${term}`)
        .pipe(map(products => products));
    } else {
      return of(defaultData);
    }
  }

  getStatusClass(status: string) {
    let className: string;
    const statusMapper: any = {
      Pending: () => {
        className = 'text-info badge badge-light text-uppercase';
      },
      Approved: () => {
        className = 'text-uppercase badge badge-light text-success';
      },
      Rejected: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Failed: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Settled: () => {
        className = 'text-success badge badge-light text-uppercase';
      },
      Success: () => {
        className = 'text-success badge badge-light text-uppercase';
      },
      InClarification: () => {
        className = 'text-warning badge badge-light text-uppercase';
      },
      Invited: () => {
        className = 'text-info badge badge-light text-uppercase';
      },
      Active: () => {
        className = 'text-uppercase badge badge-light text-success';
      },
      InActive: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      Archived: () => {
        className = 'text-danger badge badge-light text-uppercase';
      },
      default: () => {
        // console.log('default');
      },
    };
    status in statusMapper ? statusMapper[status]() : statusMapper.default();
    return className;
  }

  setInvites(data: any) {
    this.invites.next(data);
  }

  setFilter(data: any) {
    console.log('data:===>> ', data);
    console.log("filters", this.filters);
    this.filters.next(data);
  }
}
